<div class="input-container">
    <input
        type="number"
        [min]="minValue"
        [max]="maxValue"
        [value]="value"
        (change)="onValueChange($event)"
        numbersOnly
        class="input-field"
    />
    <button
        class="increment-btn"
        (click)="increaseValue()"
        [disabled]="value >= maxValue"
    >
        <img
            src="{{
                value < maxValue
                    ? '/assets/icons/input-up.svg'
                    : '/assets/icons/input-up-blur.png'
            }}"
            alt="Increment Icon"
            class="icon"
        />
    </button>
    <button
        class="decrement-btn"
        (click)="decreaseValue()"
        [disabled]="value <= minValue"
    >
        <img
            src="{{
                value > minValue
                    ? '/assets/icons/input-down.svg'
                    : '/assets/icons/input-down-blur.svg'
            }}"
            alt="Decrement Icon"
            class="icon"
        />
    </button>
</div>
